import styled from 'styled-components'

export const Wrapper = styled.div`

    .accordion__section {
        display: flex;
        flex-direction: column;
    }

    .accordion {
        background-color: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        border: none;
        outline: none;
        justify-content: space-between;
        transition: background-color 0.2s ease;

        .icon {
            font-size: 30px;
            color: #000;
        }

        a {
            color: #000;
        }
    }

    .accordion__title {
        font-family: "Lato";
        font-size: 20px;
        text-align: left;
        margin-bottom: 25px;
        margin-top: 25px;
        color: #000;
        
        p {
            font-size: 20px;
            margin: 0px;
        }          
    }

    .accordion__icon {
        font-size: 30px;
        align-self: flex-start;
    }

    .accordion__content {
        background-color: transparent;
        overflow: hidden;
        transition: max-height 0.6s ease;

        p {
            margin: 0px;
            font-size: 18px;
        }        
    }

    .accordion__text {
        font-family: "Open Sans", sans-serif;
        font-weight: 400;
        font-size: 16px;
        margin-bottom: 20px;
        line-height: 1.4;
        padding-bottom: 10px;
        font-size: 18px;
    }
`
